
import React from 'react';
import { useHistory } from 'react-router-dom';

const AlgoSalioMal = () => {
  const history = useHistory();

  const volverAlInicio = () => {
    history.push('/');
  };

  return (
    <div style={{ textAlign: 'center', padding: '40px' }}>
      <img src={`${process.env.PUBLIC_URL}/img/logo/logo-planetoffice.svg`} alt="Logo" style={{ width: '150px', marginBottom: '20px' }} />
      <h2>¡Algo salió mal!</h2>
      <p>Ha ocurrido un error inesperado. Por favor, intenta nuevamente más tarde.</p>
      <button
        onClick={volverAlInicio}
        style={{
          padding: '10px 20px',
          marginTop: '20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        Volver al inicio
      </button>
    </div>
  );
};

export default AlgoSalioMal;
